import React from "react";

import Deontologie from './Sections/Deontologie.js';
import Soutiens from "./Sections/Soutiens.js";
import Cause from "./Sections/Cause.js";
import Description from "./Sections/Description.js";
import Entete from "./Sections/Entete-terminee.js";
// import Entete from "./Sections/Entete.js";

import '../Home.css';
import { FaireunDon, UseGTMPageView } from "../Fonctions.js";

export default function Home() {
    return (
        <div id="App" style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/filigrane.svg)`
        }}>
            <div className="container">
                <FaireunDon />
                <UseGTMPageView />
                {/* <div class="CountdownTimer">
                    <CountdownTimer targetDate="2026-05-14 09:00:00" />
                </div> */}
                    {/* <Video file="teaser2026.mp4" className='video-teaser-sm'/> */}
                <Entete className="bleu bandeau-top" />
                {/* <MarkdownPage/> */}
                <Description className="blanc" />
                <Cause className="bleu" />
                <Deontologie className="blanc" />
            </div>
            <Soutiens />
        </div>
    );
}
